import { api } from "./restUtil";
import { OAuthProvider } from "model/oauth";

interface StartOauthRequest {
  is_pro?: boolean;
  pricing_model_code?: string | null;
}

interface StartOAuthResponse {
  url: string;
}

export async function startOAuth(
  provider: OAuthProvider,
  isPro?: boolean,
  pricingModelCode?: string | null
): Promise<StartOAuthResponse> {
  return await api.post<StartOauthRequest, StartOAuthResponse>(
    `/login/oauth/${provider}`,
    { is_pro: isPro, pricing_model_code: pricingModelCode }
  );
}

export interface OAuthUserInfo {
  id: string;
  email: string;
  mfa: boolean;
  status: string;
  token: string;
  return_path?: string;
}

interface ConfirmOAuthResponse {
  user?: OAuthUserInfo;
  verify_email?: boolean;
}

export async function confirmOAuth(
  provider: OAuthProvider,
  params: Record<string, string>
): Promise<ConfirmOAuthResponse> {
  return await api.post<Record<string, string>, ConfirmOAuthResponse>(
    `/login/oauth/${provider}/callback`,
    params
  );
}

interface VerifyEmailRequest {
  token: string;
}

export async function verifyEmail(token: string): Promise<OAuthUserInfo> {
  return await api.post<VerifyEmailRequest, OAuthUserInfo>("/login/oauth/verify/email", {
    token,
  });
}
